var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSignal01 = function SvgSignal01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#60646C",
    fillRule: "evenodd",
    d: "M4.257 2.814c.26.26.26.683 0 .943a6 6 0 0 0 0 8.485.667.667 0 1 1-.942.943 7.333 7.333 0 0 1 0-10.37c.26-.26.682-.26.942 0m8.486 0c.26-.26.682-.26.942 0a7.333 7.333 0 0 1 0 10.371.667.667 0 1 1-.942-.943 6 6 0 0 0 0-8.485.667.667 0 0 1 0-.943M6.143 4.7c.26.26.26.682 0 .943a3.333 3.333 0 0 0 0 4.714.667.667 0 1 1-.943.943 4.667 4.667 0 0 1 0-6.6c.26-.26.683-.26.943 0m4.714 0c.26-.26.682-.26.943 0a4.667 4.667 0 0 1 0 6.6.667.667 0 0 1-.943-.943 3.333 3.333 0 0 0 0-4.714.667.667 0 0 1 0-.943M8.5 7.333a.667.667 0 1 0 0 1.334.667.667 0 0 0 0-1.334M6.5 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0",
    clipRule: "evenodd"
  })));
};
export default SvgSignal01;